import React from 'react'
import styled from 'styled-components'
import { Wrapper, Grid, Image } from '@farewill/ui'
import { COLOR, FONT } from '@farewill/ui/tokens'
import { headingL } from '@farewill/ui/helpers/text'
import { screenMax } from '@farewill/ui/helpers/responsive'
import RichContent from '../../components/RichContent'

const StyledWrapper = styled(Wrapper)`
  position: relative;
`

const StyledRichContent = styled(RichContent)`
  & > div > :first-child {
    margin-top: 0;
  }

  h2,
  h3,
  h4,
  p {
    color: ${COLOR.BLACK};
  }

  h2 {
    ${headingL}
    font-family: ${FONT.FAMILY.DECORATIVE};
  }
`

const StyledTextureOne = styled(Image)`
  pointer-events: none;
  position: absolute;
  opacity: 0.6;
  right: -60px;
  bottom: -80px;

  ${screenMax.m`
    display: none;
  `}
`

const FreetextContent = ({
  data,
}: {
  data: GatsbyTypes.ContentfulLocalFuneralPageFreetextContent
}): React.ReactElement => (
  <StyledWrapper background={COLOR.ACCENT.PRIMARY_20}>
    <StyledTextureOne
      path="textures/detail_new_yellow01-light"
      width={350}
      widthFromXL={420}
      loading="auto"
    />
    <Grid container>
      <Grid.Item
        spanFromM={10}
        spanFromL={9}
        startColumnFromM={2}
        startColumnFromL={1}
        spanFromXL={8}
      >
        <StyledRichContent data={data} />
      </Grid.Item>
    </Grid>
  </StyledWrapper>
)

export default FreetextContent
